
// 时间戳转 '年-月-日 时:分:秒'
function timestampToTime(timestamp) {
    if(!timestamp){
        return '';
    }

    let date = new Date(timestamp);
    let Y = date.getFullYear();
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
    let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
    let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s;
}

// 计算UTF-8字节长度
function getByteLength (str) {
    if (!str) return 0;

    // 现代浏览器使用TextEncoder API（推荐）
    if (typeof TextEncoder !== 'undefined') {
        return new TextEncoder().encode(str).length;
    }

    // 兼容性方案
    let length = 0;
    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i);
        if (code <= 0x7f) {
            length += 1;  // ASCII字符
        } else if (code <= 0x7ff) {
            length += 2;  // 双字节字符
        } else if (code >= 0xd800 && code <= 0xdbff) {
            // 代理对（表情符号等）
            length += 4;
            i++; // 跳过下一个代理字符
        } else {
            length += 3;  // 三字节字符
        }
    }
    return length;
}

function byteValidator (min,max) {
    return (rule, value, callback) => {
        if (!value) {
            if (min > 0) {
                callback(new Error(`不能为空，至少需要${min}位`));
            } else {
                callback();
            }
            return;
        }

        const byteLength = getByteLength(value);

        if (min && byteLength < min) {
            callback(new Error(`至少需要${min}位`));
        } else if (max && byteLength > max) {
            callback(new Error(`最多不能超过${max}位`));
        } else {
            callback();
        }
    };
}

export {
    timestampToTime,
    byteValidator,
}